






















































helpers = require('../../helpers.coffee')

view_model =
  props: [ 'flow' , 'options' ]

  data: ->
    current_user: Session.current_user
    default_options:
      show_user: false
      row_click_action: 'show'
      action: 'dropdown'
      show_contacts_count: true
      show_reply_statistic: true

  methods:
    circleStatusClass: ->
      classes = ''
      if @flow.isProcessing()
        classes = 'circle flow-status circle-grey'
      else if @flow.isWithError()
        classes = 'circle flow-status circle-red'
      else if @flow.isPublished()
        classes = 'circle flow-status circle-green'
      else if @flow.isPaused()
        classes = 'circle flow-status circle-yellow'
      classes += ' semi-automatic' if @flow.semi_automatic
      classes


    rowClicked: (event) ->
      return if @flow.isProcessing() || jQuery(event.target).closest('.clickable-element').length
      switch @default_options.row_click_action
        when 'show'
          @viewFlow()
        when 'select'
          @$router.push "/fluxos-de-cadencia/criar/#{@flow.id}"

    viewFlow: ->
      return if @is_processing
      if @is_with_error
        @$router.push "/fluxos-de-cadencia/criar/#{@flow.id}"
      else
        @$router.push "/fluxos-de-cadencia/#{@flow.id}"

    updateFlow: (attr) ->
      attr.id = @flow.id
      @$emit 'flow-update', { attr }

    flowEditPath: ->
      "/fluxos-de-cadencia/#{@flow.id}/editar"

    editFlow: ->
      @$router.push path: @flowEditPath()

    openDestroyFlowConfirmationModal: ->
      @$emit('flow-confirm-destroy', @flow)

  computed:
    is_processing: ->
      @flow.isProcessing()

    is_with_error: ->
      @flow.isWithError()

    flow_status_message: ->
      if @flow.isProcessing()
        this.$t('flows.label.flowProcessing')
      else if @flow.isWithError()
        this.$t('flows.label.flowProcessingError')

    flow_status_message_class: ->
      if @flow.isProcessing()
        'flow-message-status flow-processing-status'
      else if @flow.isWithError()
        'flow-message-status flow-error-status'

  created: ->
    @default_options = Object.assign({}, @default_options, @options || {})


exports.default = view_model



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/list_item.vue